import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Snackbar } from '@mui/material';

const RecoverPassword = () => {
    const [email, setEmail] = useState('');
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');

    const handleClick = async () => {
        try {
            await axios.post('https://api.hireveda.com/recover-password', { email });
            setMessage('Password recovery email sent. Please check your email.');
        } catch (error) {
            setMessage('Password recovery failed: ' + (error.response?.data?.message || error.message));
        }
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <h2>Password Recovery</h2>
            <TextField
                label="Email"
                variant="outlined"
                fullWidth
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
            <Button
                variant="contained"
                color="primary"
                onClick={handleClick}
                fullWidth
            >
                Recover Password
            </Button>
            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message={message}
            />
        </div>
    );
};

export default RecoverPassword;
